<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="adc"><strong>Other books by Leland Gregory</strong></p>
<p class="center"><em>What’s the Number for 911?</em><br/><em>What’s the Number for 911 Again?</em><br/><em>The Stupid Crook Book</em><br/><em>Hey, Idiot!</em><br/><em>Idiots at Work</em><br/><em>Bush-Whacked</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_adc_r1.vue?31c5c210